// @ts-check

import { configureStore } from '@reduxjs/toolkit'

import activePageSlice from './slices/activePageSlice'
import alternativeAddressFieldsSlice from './slices/alternativeAddressFieldsSlice'
import blackPostalCodesSlice from './slices/blackPostalCodesSlice'
import contractSlice from './slices/contractSlice'
import ctgTarifSlice from './slices/ctgTarifSlice'
import customerInputValuesSlice from './slices/customerInputValuesSlice'
import electricityGridOperatorSlice from './slices/electricityGridOperatorSlice'
import fnfTarifSlice from './slices/fnfTarifSlice'
import packageProposalDataCloud4Slice from './slices/packageProposalCloud4DataState'
import productDetailSlice from './slices/productDetailSlice'
import tarifSlice from './slices/tarifSlice'
import waermeTarifSlice from './slices/waermeTarifSlice'

// Add slices here
export const store = configureStore({
  reducer: {
    productdetail: productDetailSlice,
    activepage: activePageSlice,
    blackpostalcodes: blackPostalCodesSlice,
    customervalues: customerInputValuesSlice,
    packageproposal: packageProposalDataCloud4Slice,
    contract: contractSlice,
    tarif: tarifSlice,
    waermetarif: waermeTarifSlice,
    ctgtarif: ctgTarifSlice,
    fnftarif: fnfTarifSlice,
    electricitygridoperator: electricityGridOperatorSlice,
    alternativeAddressFields: alternativeAddressFieldsSlice
  }
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
